import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

/**
 * Updates restaurant preferences (drinks, accompanimentPrice, etc.)
 */
export default {
  url(payload) {
    const { restaurantId, storeId } = payload || {}
    const id = restaurantId || storeId
    if (!id) throw new Error('restaurantId is required for updating preferences')
    
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_RESTAURANT_DETAIL, { pathParams: { restaurantId: id } })
  },

  method() {
    return 'POST'
  },

  format(payload) {
    // Only send the fields that need to be updated
    const { 
      drinks, 
      accompanimentPrice,
      storeName,
      description,
      logo,
      images,
      address,
      city,
      phone,
      email,
      isOpen,
      isVisible,
      cuisine,
      onboardingDone
    } = payload || {}

    return {
      drinks,
      accompanimentPrice,
      storeName,
      description,
      logo,
      images,
      address,
      city,
      phone,
      email,
      isOpen,
      isVisible,
      cuisine,
      onboardingDone
    }
  },

  parse(raw = {}) {
    if (!raw.success) {
      return { 
        statusCode: raw?.statusCode || 400, 
        message: raw?.message || 'Erreur lors de la mise à jour des préférences', 
        data: null 
      }
    }
    return { 
      statusCode: 200, 
      message: 'Préférences mises à jour', 
      data: raw.data 
    }
  },
}
